import { UwidFormatT } from "../components/well-list/context/WellListContext";

const UWID_FORMAT_SESSION_KEY = "eva-uwid-format";

export const sessionStorageUwidFormat = {
  get: (): UwidFormatT => {
    try {
      const stored = sessionStorage.getItem(UWID_FORMAT_SESSION_KEY);
      if (
        stored === "entityName" ||
        stored === "uwid" ||
        stored === "api10" ||
        stored === "mosaic"
      ) {
        return stored;
      }
    } catch (error) {
      // Silently fallback on error
    }
    return "entityName"; // Default fallback
  },

  set: (format: UwidFormatT): void => {
    try {
      sessionStorage.setItem(UWID_FORMAT_SESSION_KEY, format);
    } catch (error) {
      // Silently fail on error (e.g., storage quota exceeded)
    }
  }
};
